export default __webpack_public_path__ + "static/media/division-1.db5e21fc.png";